export const MIN_LENGTH = 4;
export const DECIMAL_POINT = '.';
export const DEBOUNCE_MS = 300;

export const containsAlphaChars = (value: string): boolean => {
  const pattern = /[A-Za-z]+/;
  const match = value.match(pattern);
  return !!match && match.length > 0;
};

export const validToLookup = (value: string) =>
  value?.length >= MIN_LENGTH &&
  !value.includes(DECIMAL_POINT) &&
  containsAlphaChars(value);
